import type { IconData } from '@stacksjs/iconify-core'

export const internetNetworkComputerDownload: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M28.955 22.85h-25.9V7.62h-1.53V25.9h1.53v1.53h9.14v1.52h1.52v-1.52h4.57v1.52h1.53v-1.52h9.14V25.9h1.52V7.62h-1.52zm-7.62-16.76h7.62v1.53h-7.62Zm-9.14 24.38v-1.52h-1.52V32h10.66v-3.05h-1.52v1.52zm1.52-27.42h4.57v1.52h-4.57Zm0-3.05h4.57v1.52h-4.57Z\"/><path fill=\"currentColor\" d=\"M16.765 19.81v-1.53h1.52v-1.52h1.53v-1.52h1.52v-1.53h-3.05V6.09h-4.57v7.62h-3.04v1.53h1.52v1.52h1.52v1.52h1.53v1.53zM3.055 6.09h7.62v1.53h-7.62Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default internetNetworkComputerDownload
